import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { classNames } from 'primereact/utils';

import { RoleProvider, useRoleContext } from '../hooks/useRoleContext';
import Header from './Header/Header';
import Home from '../view/Home/Home';
// import Footer from './Footer/Footer';
import Sidebar from './Sidebar/Sidebar';
import SpinnerOverlay from '../components/SpinnerOverlay/SpinnerOverlay';
import './Layout.scss';

const Layout = ({ children }: any) => {
  const { role, isRoleFetched, isRoleFetching } = useRoleContext();
  const [collapseSidebar, setCollapseSidebar] = useState(false);
  const [filterResult, setFilterResult] = useState<{
    year: number | null;
    customer: number | null;
    category: number | null;
    brand: number | null;
    isSummaryView: boolean;
  } | null>(null);

  const location = useLocation();
  const pathArr = location.pathname?.split('/');
  const currPathName = pathArr[1];

  useEffect(() => {
    if (currPathName === 'manage-users' || currPathName === 'edit-user' || currPathName === 'add-user') {
      setCollapseSidebar(true);
    } else {
      setCollapseSidebar(false);
    }
  }, [currPathName]);

  if (isRoleFetched) {
    return (
      <div className="layout-container">
        <div className="header-container">
          <Header />
        </div>

        <div className="main-body">
          <div
            className={classNames({
              'sidebar-container': true,
              'collapsed-menu': collapseSidebar
            })}
            style={{ flex: collapseSidebar ? '0 0 40px' : '0 0 270px' }}
          >
            <Sidebar collapsed={collapseSidebar} onCollapse={setCollapseSidebar} onGo={setFilterResult} />
          </div>

          <div className="layout-body">
            <div className="layout-body-inner">
              {/* Pass filterResult to Home if present */}
              {(currPathName === '' || currPathName === 'home')
                ? <Home filterResult={filterResult} />
                : children}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="card">
        <SpinnerOverlay />
      </div>
    );
  }
};

const LayoutWithProvider = ({ children }: any) => (
  <RoleProvider>
    <Layout>{children}</Layout>
  </RoleProvider>
);

export default LayoutWithProvider;
